"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulingShiftAssignmentAudit_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var User_1 = require("./User");
var SchedulingShiftAssignment_1 = require("./SchedulingShiftAssignment");
var SchedulingShiftAssignmentAudit_Factory = /** @class */ (function () {
    function SchedulingShiftAssignmentAudit_Factory() {
    }
    SchedulingShiftAssignmentAudit_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ActionDescription: model.ActionDescription,
            ActionUser: User_1.User_Factory.CreateIncoming(model.ActionUser),
            ActionUserId: model.ActionUserId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SchedulingShiftAssignment: SchedulingShiftAssignment_1.SchedulingShiftAssignment_Factory.CreateIncoming(model.SchedulingShiftAssignment),
            SchedulingShiftAssignmentID: model.SchedulingShiftAssignmentID,
        };
        return result;
    };
    SchedulingShiftAssignmentAudit_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ActionDescription: model.ActionDescription,
            ActionUser: User_1.User_Factory.CreateOutgoing(model.ActionUser),
            ActionUserId: model.ActionUserId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SchedulingShiftAssignment: SchedulingShiftAssignment_1.SchedulingShiftAssignment_Factory.CreateOutgoing(model.SchedulingShiftAssignment),
            SchedulingShiftAssignmentID: model.SchedulingShiftAssignmentID,
        };
        return result;
    };
    return SchedulingShiftAssignmentAudit_Factory;
}());
exports.SchedulingShiftAssignmentAudit_Factory = SchedulingShiftAssignmentAudit_Factory;
